import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { useLastLocation } from 'react-router-last-location';
import URL from "../../../constant/URL";
import TYPE from "../../../constant/TYPE";
import http from "../../../http/http";
import { setLoadingAction, clearLoadingAction } from "../../../redux/loading";
import { mathpidLogAPICall } from "../../../redux/logData";
import Header from "./Header";
import View from "./view/View";
import Indexing from "./Indexing";
import useAmplitude from "../../../hooks/useAmplitude";
import { appsflyer, appsflyerEventName } from "../../../utils/appsflyer";

const CheckWrongAnswer = () => {

  const [ data, setData ] = useState( [] );
  // const [beforeCurrentPage, setBeforeCurrentPage] = useState(-1);

  const history = useHistory();
  const location = useLocation();
  const lastLocation = useLastLocation();

  const user = useSelector( state => state.user );

  const dispatch = useDispatch();
  const { setAmplitudeLog } = useAmplitude();
  const setLoading = payload => { dispatch( setLoadingAction( payload ) ) };
  const clearLoading = () => { dispatch( clearLoadingAction() ) };
  const setLog = payload => { dispatch( mathpidLogAPICall( payload ) ) };

  const { stgCd, lrnEntyScnCd, currentIndex } = location.state || {};
  const { locale, learnerId } = user.info || {};

  useEffect(() => {
    console.log("***** 오답확인 페이지")
  }, [])

  useEffect(() => {     
    return () => {
      amplitudeCall(null, 'close')
    }
  })

  useEffect( () => {
    setLoading( { spinnerType : '1', isShowSpinner : true } );
    if ( stgCd && locale && learnerId ) {
      http.request( {
        url : URL.API.LEARNING.COMMON.WRANSR,
        method : http.METHOD.POST,
        data : {
          langCd : locale,
          lrnMbrId : learnerId,
          lrnEntyScnCd: lrnEntyScnCd ? lrnEntyScnCd : TYPE.LEARNING.TOPIC,
          stgCd
        },
        success : ( data ) => {
          setData( data || [] );
          changeCurrentIndex( undefined === currentIndex ? 0 : currentIndex );
        },
        error : clearLoading
      } );
    }
  }, [ stgCd, lrnEntyScnCd, locale, learnerId ] );

  useEffect( () => {
    if ( data[ currentIndex ] ) {
      setLog( {
        verbId : TYPE.LOG.VERB.OPENED,
        objectId : TYPE.LOG.OBJECT.EXPLANATION,
        idName : 'stgCd',
        idValue : stgCd,
        contentInfo : { questionIdName : 'qstCd', questionIdValue : data[ currentIndex ].qstCd }
      } );
    }
  }, [ data, currentIndex ] );

  const amplitudeCall = (beforeCurrentPage, type) => {
    if (!lastLocation?.pathname || lastLocation.pathname !== URL.LEARNING.CHECK_WRONG_ANSWER) return;
    const wransr = data[beforeCurrentPage];
    const isAnswer = document.getElementsByClassName('btn_chansr on');
    setAmplitudeLog({
      eventName: {
        name: '문항별 오답확인',
        event: {
          "소주제이름": wransr?.stgNm ? wransr?.stgNm : data[0]?.stgNm,
          "소주제코드": stgCd,
          "문항코드": wransr?.qstCd ? wransr?.qstCd : data[0]?.qstCd,
          "정답보기여부": isAnswer && isAnswer.length > 0 ? 'Y' : 'N',
          "커리큘럼그룹": wransr?.thmaNm ? wransr?.thmaNm : data[0]?.thmaNm,
          "커리큘럼명": wransr?.stepNm ? wransr?.stepNm : data[0]?.stepNm
        }
      },
      isHackleSend: true,
    });
    if (type === 'close') {
      appsflyer({
        eventName: appsflyerEventName.check_incorrections,
        eventParams: {
          af_content_type: wransr?.stgNm ? wransr?.stgNm : data[0]?.stgNm,
          af_content_id: stgCd,
        }
      })
    }
  };

  const changeCurrentIndex = ( index ) => {
    if (undefined !== currentIndex) amplitudeCall(currentIndex);
    
    history.replace( { pathname : URL.LEARNING.CHECK_WRONG_ANSWER, state : { ...location.state, currentIndex : index } } );
  };

  return (
    <div className="layout-def layout-lc theme-gray">
      <Header 
        amplitudeCall={amplitudeCall}
      />
      <div className="container ovy-h">
        <div className="inner">
          <div className="wa-wrapper">
            <Indexing data={ data } currentIndex={ currentIndex } onClick={ changeCurrentIndex } />
            <View data={ data } currentIndex={ currentIndex } />
          </div>
        </div>
      </div>
    </div>
  );

};

export default CheckWrongAnswer;
